import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { appendTeamMemberLawyerId } from "../../../../styles/styles";

export const createTask = createAsyncThunk(
  "createTask",
  async ({ url, body, token }) => {
    try {
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }
);

export const createTaskTemplate = createAsyncThunk(
  "createTaskTemplate",
  async ({ url, body, token }) => {
    try {
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }
);

export const createTaskList = createAsyncThunk(
  "createTaskList",
  async ({ url, body, token }) => {
    try {
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      throw error?.response?.data || error?.message;
    }
  }
);

export const createTaskType = createAsyncThunk(
  "createTaskType",
  async ({ url, body, token }) => {
    try {
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      toast.error("Failed to create Task type");
      throw error.response?.data || error.message;
    }
  }
);

export const getAllTaskType = createAsyncThunk(
  "getAllTaskType",
  async ({ url, token, page, pageSize }) => {
    try {
      let paginatedUrl = url;
      const params = [];
      if (page !== undefined) {
        params.push(`page=${page}`);
      }
      if (pageSize !== undefined) {
        params.push(`page_size=${pageSize}`);
      }
      if (params.length > 0) {
        const separator = url.includes("?") ? "&" : "?";
        paginatedUrl = `${url}${separator}${params.join("&")}`;
      }

      const response = await axios.get(paginatedUrl, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      toast.error("Failed to get task type");
      throw error.response?.data || error.message;
    }
  }
);

export const getAllTask = createAsyncThunk(
  "getAllTask",
  async ({ url, token, page, pageSize, teamMemberLawyerId }) => {
    try {
      let paginatedUrl = appendTeamMemberLawyerId(url, teamMemberLawyerId);
      const params = [];
      if (page !== undefined) {
        params.push(`page=${page}`);
      }
      if (pageSize !== undefined) {
        params.push(`page_size=${pageSize}`);
      }
      if (params.length > 0) {
        const separator = paginatedUrl.includes("?") ? "&" : "?";
        paginatedUrl = `${paginatedUrl}${separator}${params.join("&")}`;
      }

      const response = await axios.get(paginatedUrl, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      toast.error("Failed to get tasks");
      throw error.response?.data || error.message;
    }
  }
);

export const getAllTaskTemplate = createAsyncThunk(
  "getAllTaskTemplate",
  async ({ url, token, page, pageSize, teamMemberLawyerId }) => {
    try {
      let paginatedUrl = appendTeamMemberLawyerId(url, teamMemberLawyerId);
      const params = [];
      if (page !== undefined) {
        params.push(`page=${page}`);
      }
      if (pageSize !== undefined) {
        params.push(`page_size=${pageSize}`);
      }
      if (params.length > 0) {
        const separator = paginatedUrl.includes("?") ? "&" : "?";
        paginatedUrl = `${paginatedUrl}${separator}${params.join("&")}`;
      }

      const response = await axios.get(paginatedUrl, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      toast.error("Failed to get task templates");
      throw error.response?.data || error.message;
    }
  }
);

export const getAllTaskList = createAsyncThunk(
  "getAllTaskList",
  async ({ url, token, page, pageSize }) => {
    try {
      let paginatedUrl = url;
      if (page !== undefined && pageSize !== undefined) {
        const separator = url?.includes("?") ? "&" : "?";
        paginatedUrl = `${url}${separator}page=${page}&page_size=${pageSize}`; // url modify with page and page size
      }

      const response = await axios?.get(paginatedUrl, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      toast.error("Failed to get task list");
      throw error.response?.data || error.message;
    }
  }
);

export const updateTaskOrType = createAsyncThunk(
  "updateTaskOrType",
  async ({ url, body, token }) => {
    try {
      const response = await axios.patch(url, body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const updateTaskList = createAsyncThunk(
  "task/updateTaskList",
  async ({ url, body, token }, { rejectWithValue }) => {
    try {
      const response = await axios.put(url, body, {
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const TaskSlice = createSlice({
  name: "TaskSlice",
  initialState: {
    allTask: null,
    taskPagination: {
      page: 1,
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
    allTaskType: null,
    taskTypePagination: {
      page: 1,
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
    allTaskList: null,
    taskListPagination: {
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
    allTaskTemplate: null,
    taskTemplatePagination: {
      page: 1,
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTask.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create task type";
      })
      .addCase(createTaskType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTaskType.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createTaskType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create task type";
      })
      .addCase(getAllTaskType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTaskType.fulfilled, (state, action) => {
        state.loading = false;
        state.allTaskType = action?.payload?.results;
        state.taskTypePagination = {
          ...action?.payload?.pagination,
          count: action?.payload?.count,
          next: action?.payload?.next,
          previous: action?.payload?.previous,
        };
      })
      .addCase(getAllTaskType.rejected, (state, action) => {
        state.loading = false;
        state.allTaskType = action?.payload || "Failed to get task type";
      })
      .addCase(getAllTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTask.fulfilled, (state, action) => {
        state.loading = false;
        state.allTask = action?.payload?.results;
        state.taskPagination = {
          ...action?.payload?.pagination,
          count: action?.payload?.count,
          next: action?.payload?.next,
          previous: action?.payload?.previous,
        };
      })
      .addCase(getAllTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to get tasks";
      })
      .addCase(updateTaskOrType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTaskOrType.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateTaskOrType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to edit task type";
      })
      .addCase(updateTaskList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTaskList.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateTaskList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to edit task list";
      })
      .addCase(createTaskList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTaskList.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createTaskList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create task list";
      })
      .addCase(getAllTaskList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTaskList.fulfilled, (state, action) => {
        state.loading = false;
        state.allTaskList = action?.payload?.results;
        state.taskListPagination = {
          ...action?.payload?.pagination,
          count: action?.payload?.count,
          next: action?.payload?.next,
          previous: action?.payload?.previous,
        };
      })
      .addCase(getAllTaskList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to get task list";
      })
      .addCase(createTaskTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTaskTemplate.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createTaskTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create task template";
      })
      .addCase(getAllTaskTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTaskTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.allTaskTemplate = action?.payload?.results;
        state.taskTemplatePagination = {
          ...action?.payload?.pagination,
          count: action?.payload?.count,
          next: action?.payload?.next,
          previous: action?.payload?.previous,
        };
      })
      .addCase(getAllTaskTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to get task templates";
      });
  },
});

export const TaskSliceReducer = TaskSlice.reducer;
